import IListFilter from "@/models/IListFilter";
import StringHelper from "@/helpers/StringHelper";

export default abstract class CustomerItemListFilter implements IListFilter{
	public fulltext: string | null = null;

	clear(): void {
		this.fulltext = null;
	}

	hasFilter(): boolean {
		return !StringHelper.isEmpty(this.fulltext);
	}
}
